import { useEffect, useRef } from "react";

// Poll `fn` every `ms` while the tab is visible; pauses in background tabs and
// refreshes immediately when the tab comes back. Always calls the latest `fn`.
export const usePolling = (fn, ms, deps = []) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    let id = null;
    const tick = () => { if (document.visibilityState !== "hidden") ref.current(); };
    const stop = () => { if (id) clearInterval(id); id = null; };
    const start = () => { stop(); tick(); id = setInterval(tick, ms); };
    const onVis = () => (document.visibilityState === "hidden" ? stop() : start());
    start();
    document.addEventListener("visibilitychange", onVis);
    return () => { stop(); document.removeEventListener("visibilitychange", onVis); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ms, ...deps]);
};
